<template>
	<b-row>
		<b-col cols="12" class="border-bottom pb-3">
			<b-row>
				<b-col cols="12" lg="6">
					<span class="d-inline-block rounded bgray-700 text-light f-85 fw-500 px-2 py-1">{{ sub_code }}</span>
				</b-col>
				<b-col cols="12" lg="6">
					<div class="text-right">
						<b-btn size="sm" variant="danger">번역 전체 초기화</b-btn>
					</div>
				</b-col>
			</b-row>
		</b-col>
		<b-col cols="12" :class="[{ 'mb-2': !has_sub_meta_translation }]">
			<b-row class="align-items-center border-top border-bottom pt-2 mb-2 pb-2 mb-2 bgray-100">
				<b-col cols="auto">
					<h5 class="mb-0">기본 정보</h5>
                    <BIconInfoCircle />
				</b-col>
				<b-col col class="text-right">
					<div class="">
						<b-form-select
							v-model="selected_meta_lang"
							:options="sub_meta_lang"
							class="w-auto mr-2"
							size="sm"
							/>
						<b-btn
							variant="warning"
							class="mr-2"
							:disabled="is_translation_busy"
							@click="generateSubMetaTraslation"
							size="sm"
							>
							번역 자동 생성
						</b-btn>
						<b-btn
							variant="danger"
							class="mr-2"
							:disabled="!is_edited_meta_data"
							@click="resetSubMeta"
							size="sm"
							>
							최근 저장내역으로 되돌리기
						</b-btn>
						<b-btn
							variant="primary"
							:disabled="is_translation_busy || !has_sub_meta_translation || !is_edited_meta_data"
							@click="saveEditedSubMetaData"
							size="sm"
							>
							저장
						</b-btn>
					</div>
				</b-col>
			</b-row>
		</b-col>
		<b-col cols="12" v-show="!has_sub_meta_translation">
			<b-row>
				<b-col cols="12" md="6" class="ml-auto">
					<div class="bg-warning rounded px-3 py-2">
						번역되지 않은 데이터는 <strong>번역자동 생성 버튼</strong> 을 눌러 번역생성 후 수정할 수 있습니다.
					</div>
				</b-col>
			</b-row>
		</b-col>
		<b-col cols="12" class="mb-4">
			<b-row>
				<b-col cols="12" class="border-bottom mb-2">
					<b-form-group
						id="input-sub-title-group"
						:label-for="`input-sub-title-${selected_meta_lang}`"
						>
						<template #label>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold">Title</span>

								<b-btn variant="warning" size="sm"
									@click="generateTempTranslation(sub_data.sub_name)"
									:disabled="isFieldEmpty(sub_data.sub_name)">
									부분 자동 번역
								</b-btn>
							</div>
						</template>

						<b-form-text id="input-sub-title-eng-help" class="h6 font-weight-normal mb-2">
							(국문) {{ !sub_data.sub_name ? '(미입력)' : sub_data.sub_name }}
						</b-form-text>
                        

                        <b-input-group>
                            <b-form-input
                                v-show="selected_meta_lang === 'ea'"
                                id="input-sub-title-e"
                                v-model="editable_sub_data_meta.sub_name_e"
                                placeholder="sub_name 영문 번역"
                                @input="checkIsEditingMetaData($event, sub_data.sub_name_e)"
                                :disabled="isFieldEmpty(sub_data.sub_name_e)"
                                trim
                                />
                            <b-form-input
                                v-show="selected_meta_lang === 'ca'"
                                id="input-sub-title-c"
                                v-model="editable_sub_data_meta.sub_name_c"
                                placeholder="sub_name 중문 번역"
                                @input="checkIsEditingMetaData($event, sub_data.sub_name_c)"
                                :disabled="isFieldEmpty(sub_data.sub_name_c)"
                                trim
                                />

                            <template #append>
                                <b-btn variant="warning" size="sm"
                                    @click="generateTempTranslation(sub_data.sub_name)"
                                    :disabled="isFieldEmpty(sub_data.sub_name)">
                                    <BIconTranslate />
                                </b-btn>
                            </template>
                        </b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="12" class="border-bottom mb-2">
					<b-form-group
						id="input-sub-description-group"
						label="Description"
						:label-for="`input-sub-description-${selected_meta_lang}`"
						>

						<template #label>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold">Description</span>

								<b-btn variant="warning" size="sm"
									@click="generateTempTranslation(sub_data.sub_description)"
									:disabled="isFieldEmpty(sub_data.sub_description)">
									부분 자동 번역
								</b-btn>
							</div>
						</template>

						<b-form-text id="input-sub-description-eng-help" class="h6 font-weight-normal mb-2">
							(국문) {{ sub_data.sub_description === '' ? '없음' : sub_data.sub_description }}
						</b-form-text>
                        
                        <b-input-group>
                            <b-form-input
                                v-show="selected_meta_lang === 'ea'"
                                id="input-sub-description-e"
                                v-model="editable_sub_data_meta.sub_description_e"
                                placeholder="sub_description 영문 번역"
                                @input="checkIsEditingMetaData($event, sub_data.sub_description_e)"
                                :disabled="isFieldEmpty(sub_data.sub_description_e)"
                                trim
                                />
                            <b-form-input
                                v-show="selected_meta_lang === 'ca'"
                                id="input-sub-description-c"
                                v-model="editable_sub_data_meta.sub_description_c"
                                placeholder="sub_description 중문 번역"
                                @input="checkIsEditingMetaData($event, sub_data.sub_description_c)"
                                :disabled="isFieldEmpty(sub_data.sub_description_c)"
                                trim
                                />

                            <template #append>
                                <b-btn variant="warning" size="sm"
                                    @click="generateTempTranslation(sub_data.sub_description)"
                                    :disabled="isFieldEmpty(sub_data.sub_description)">
                                    <BIconTranslate />
                                </b-btn>
                            </template>
                        </b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="12" class="border-bottom mb-2">
					<b-form-group
						id="input-sub-info-group"
						label="Info"
						:label-for="`input-sub-info-${selected_meta_lang}`"
						>
						<template #label>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold">Info</span>

								<b-btn variant="warning" size="sm"
									@click="generateTempTranslation(sub_data.sub_info)"
									:disabled="isFieldEmpty(sub_data.sub_info)">
									부분 자동 번역
								</b-btn>
							</div>
						</template>

						<b-form-text
							id="input-sub-info-eng-help"
							class="h6 font-weight-normal mb-2"
							placeholder="영문"
							>							
							(국문) {{ sub_data.sub_info === '' ? '없음' : sub_data.sub_info }}
						</b-form-text>

                        <b-input-group>
                            <b-form-textarea
                                v-show="selected_meta_lang === 'ea'"
                                id="input-sub-info-e"
                                v-model="editable_sub_data_meta.sub_info_e"
                                placeholder="sub_info 영문 번역"
                                @input="checkIsEditingMetaData($event, sub_data.sub_info_e, 'info_e')"
                                :disabled="isFieldEmpty(sub_data.sub_info_e)"
                                rows="4"
                                max-rows="12"
                                trim
                                />
                            <b-form-textarea
                                v-show="selected_meta_lang === 'ca'"
                                id="input-sub-info-c"
                                v-model="editable_sub_data_meta.sub_info_c"
                                placeholder="sub_info 중문 번역"
                                @input="checkIsEditingMetaData($event, sub_data.sub_info_c, 'info_c')"
                                :disabled="isFieldEmpty(sub_data.sub_info_c)"
                                rows="4"
                                max-rows="12"
                                trim
                                />
                                
                            <template #append>
                                <b-btn variant="warning" size="sm"
                                    @click="generateTempTranslation(sub_data.sub_info)"
                                    :disabled="isFieldEmpty(sub_data.sub_info)">
                                    <BIconTranslate />
                                </b-btn>
                            </template>
                        </b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group
						id="input-sub-enableNA-group"
						label="해당없음 라벨"
						:label-for="`input-sub-enableNA-${selected_meta_lang}`"
						>

						<template #label>
							<div class="d-flex align-items-center justify-content-between mb-2">
								<span class="font-weight-bold">해당없음 라벨</span>

								<b-btn variant="warning" size="sm"
									@click="generateTempTranslation(sub_data.sub_data_header.enable_na_label)"
									:disabled="!sub_data.sub_data_header.enable_na || isFieldEmpty(sub_data.sub_data_header.enable_na_label)">
									부분 자동 번역
								</b-btn>
							</div>
						</template>

						<template v-if="!sub_data.sub_data_header.enable_na">
							<b-form-textarea
								id="input-sub-enableNA-eng-help"
								class="h6 font-weight-normal mb-2"
								placeholder="영문"
								value="(해당없음 미적용 문항)"
								disabled
								>							
							</b-form-textarea>
						</template>
						<template v-else>
							<b-form-text
								id="input-sub-enableNA-eng-help"
								class="h6 font-weight-normal mb-2"
								placeholder="영문"
								>							
								(국문) {{ !sub_data.sub_data_header.enable_na_label ? '없음' : sub_data.sub_data_header.enable_na_label }}
							</b-form-text>

                            <b-input-group>
                                <b-form-textarea
                                    v-show="selected_meta_lang === 'ea'"
                                    id="input-sub-enableNA-e"
                                    v-model="editable_sub_data_meta.enable_na_label_ea"
                                    placeholder="해당없음 라벨 - 영문 번역"
                                    @input="checkIsEditingMetaData($event, sub_data.sub_data_header.enable_na_label_ea, 'enable_na_label_ea')"
                                    :disabled="isFieldEmpty(sub_data.sub_data_header.enable_na_label)"
                                    rows="4"
                                    max-rows="12"
                                    trim
                                    />
                                <b-form-textarea
                                    v-show="selected_meta_lang === 'ca'"
                                    id="input-sub-enableNA-c"
                                    v-model="editable_sub_data_meta.enable_na_label_ca"
                                    placeholder="해당없음 라벨 - 중문 번역"
                                    @input="checkIsEditingMetaData($event, sub_data.sub_data_header.enable_na_label_ca, 'enable_na_label_ca')"
                                    :disabled="isFieldEmpty(sub_data.sub_data_header.enable_na_label)"
                                    rows="4"
                                    max-rows="12"
                                    trim
                                    />
                                    
                                <template #append>
                                    <b-btn variant="warning" size="sm"
                                        @click="generateTempTranslation(sub_data.sub_data_header.enable_na_label)"
                                        :disabled="isFieldEmpty(sub_data.sub_data_header.enable_na_label)">
                                        <BIconTranslate />
                                    </b-btn>
                                </template>
                            </b-input-group>
						</template>
					</b-form-group>
				</b-col>
			</b-row>
		</b-col>
		
		<b-col cols="12">
			<b-row class="align-items-center border-top border-bottom pt-2 mb-2 pb-2 mb-3 bgray-100">
				<b-col cols>
					<h5 class="mb-0"> 문항(Structure) </h5>
				</b-col>
				<b-col cols="auto" class="text-right">
					<div>
						<div>
							<b-form-select
								class="w-auto mr-2"
								v-model="selected_contents_lang"
								:options="sub_conetent_data_lang"
								:disabled="disabled_select_language_by_sub_type"
								size="sm"
								/>
							<b-btn
								variant="warning"
								class="mr-2"
								:disabled="is_translation_busy"
								@click="generateSubDataContentTraslation"
								size="sm"
								>
								번역 자동 생성
							</b-btn>
							<b-btn
								variant="danger"
								class="mr-2"
								:disabled="!is_edited_sub_element_contents && !is_edited_sub_data_contents"
								@click="() => resetSubDataContent()"
								size="sm"
								>
								최근 저장내역으로 되돌리기
							</b-btn>
							<b-btn
								variant="primary"
								:disabled="is_translation_busy || (!has_sub_data_translation && !is_edited_sub_data_contents)"
								@click="saveEditedSubDataContent"
								size="sm"
								>
								저장
							</b-btn>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" v-show="!has_sub_data_translation" class="text-right mb-3">
					<span class="bg-warning rounded px-3 py-2">
						번역되지 않은 데이터는 <strong>번역자동 생성 버튼</strong> 을 눌러 번역생성 후 수정할 수 있습니다.
					</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<!-- sub_type === 'radio' ~ (start) -->
					<template v-if="sub_type === 'radio'">
						<b-table-simple bordered hover>
							<b-thead>
								<b-tr>
									<b-th> index </b-th>
									<b-th> text </b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<template v-for="(structure, str_idx) in editable_sub_data_contents.structure">
									<b-tr v-if="Object.keys(structure).length"
										:key="`radio-${sub_code}-sub_data_contents-structure-${str_idx}`"
										>
										<b-td>
											{{ Number(str_idx) + 1 }}
										</b-td>
										<b-td>
											<b-form-group
												:id="`fieldset-${sub_code}-radio-contents-structure-${str_idx}-text-${selected_contents_lang}`"
												:label="`(국문) ${isFieldEmpty(structure.text) ? '없음' : structure.text}`"
												:label-for="`input-radio-content-sub-text-${selected_contents_lang}`"
												>

												<b-input-group>
													<b-form-input
														v-show="selected_contents_lang === 'ea'"
														:id="`input-radio-${sub_code}-content-sub-text-e`"
														v-model="structure.text_ea"
														:placeholder="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text) ? '국문 텍스트를 먼저 입력해주세요.' : '영중문 번역을 자동 생성 또는 직접입력 해주세요.'"
														@input="changeEditingSubDataContentsStructure"
														:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text)"
														trim
														/>
													<b-form-input
														v-show="selected_contents_lang === 'ca'"
														:id="`input-radio-${sub_code}-content-sub-text-c`"
														v-model="structure.text_ca"
														:placeholder="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text) ? '국문 텍스트를 먼저 입력해주세요.' : '영중문 번역을 자동 생성 또는 직접입력 해주세요.'"
														@input="changeEditingSubDataContentsStructure"
														:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text)"
														trim
														/>
													<template #append>
														<b-btn variant="warning" size="sm"
															@click="generateTempTranslation(structure.text)"
															:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text)">
															<BIconTranslate />
														</b-btn>
													</template>
												</b-input-group>
											</b-form-group>
										</b-td>
									</b-tr>
								</template>
							</b-tbody>
						</b-table-simple>
					</template>
					<!-- sub_type === 'checkbox' ~ (start) -->
					<template v-if="sub_type === 'checkbox'">
						<b-table-simple bordered hover>
							<b-thead>
								<b-tr>
									<b-th> index </b-th>
									<b-th> contents </b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<template v-for="(structure, str_idx) in editable_sub_data_contents.structure">
									<b-tr v-if="Object.keys(structure).length"
										:key="`checkbox-${sub_code}-sub_data_contents-structure-${str_idx}`"
										>
										<b-td>
											{{ Number(str_idx) + 1 }}
										</b-td>
										<b-td>
											<b-row>
												<b-col cols="12">
													<b-form-group
														:id="`fieldset-${sub_code}-checkbox-content-${str_idx}-text-${selected_contents_lang}`"
														:label="`(텍스트, 국문) ${isFieldEmpty(structure.text) ? '(없음)' : structure.text}`"
														:label-for="`input-checkbox-${sub_code}-content-${str_idx}-text-${selected_contents_lang}`"
														>
														<b-input-group>
															<b-form-input
																v-show="selected_contents_lang === 'ea'"
																:id="`input-checkbox-${sub_code}-content-${str_idx}-text-ea`"
																v-model="structure.text_ea"
																@input="changeEditingSubDataContentsStructure"
																:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text)"
																:placeholder="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text) ? '국문 텍스트를 먼저 입력해주세요' : '영중문 번역을 자동 생성 또는 직접입력 해주세요.'"
																trim
																/>
															<b-form-input
																v-show="selected_contents_lang === 'ca'"
																:id="`input-checkbox-${sub_code}-content-${str_idx}-text-ca`"
																v-model="structure.text_ca"
																@input="changeEditingSubDataContentsStructure"
																:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text)"
																:placeholder="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text) ? '국문 텍스트를 먼저 입력해주세요' : '영중문 번역을 자동 생성 또는 직접입력 해주세요.'"
																trim
																/>
															<template #append>
																<b-btn variant="warning" size="sm"
																	@click="generateTempTranslation(structure.text)"
																	:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].text)">
																	<BIconTranslate />
																</b-btn>
															</template>
														</b-input-group>
														
													</b-form-group>
												</b-col>
												<b-col cols="12">
													<b-form-group
														:id="`fieldset-${sub_code}-checkbox-content-${str_idx}-placeholder-${selected_contents_lang}`"
														:label="`(가이드 텍스트, 국문) ${isFieldEmpty(structure.placeholder) ? '(없음)' : structure.placeholder}`"
														:label-for="`input-checkbox-${sub_code}-content-${str_idx}-placeholder-${selected_contents_lang}`"
														>

                                                        <b-form-text :id="`input-checkbox-${sub_code}-content-${str_idx}-placeholder-help-block`" class="font-italic mb-1">
                                                            입력창 가이드 문구가 없을 경우, 기본 문구인 국문은 "상세설명"이, 외국어는 번역되어 기본 문구가 출력됩니다.
                                                        </b-form-text>

														<b-input-group>
															<b-form-input
																v-show="selected_contents_lang === 'ea'"
																:id="`input-checkbox-${sub_code}-content-${str_idx}-placeholder-ea`"
																v-model="structure.placeholder_ea"
																@input="changeEditingSubDataContentsStructure"
																placeholder="번역 자동 생성를 통해 번역을 생성 후 수정하실 수 있으십니다."
																:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].placeholder) ? '가이드 텍스트 - 국문을 입력해주세요' : '영중문 번역을 입력해주세요.'"
																trim
																/>
															<b-form-input
																v-show="selected_contents_lang === 'ca'"
																:id="`input-checkbox-${sub_code}-content-${str_idx}-placeholder-ca`"
																v-model="structure.placeholder_ca"
																@input="changeEditingSubDataContentsStructure"
																placeholder="번역 자동 생성를 통해 번역을 생성 후 수정하실 수 있으십니다."
																:disabled="isFieldEmpty(sub_data.sub_data_contents.structure[str_idx].placeholder) ? '가이드 텍스트 - 국문을 입력해주세요' : '영중문 번역을 입력해주세요.'"
																trim
																/>

															<template #append>
																<b-btn variant="warning" size="sm"
																	@click="generateTempTranslation(structure.placeholder)"
																	:disabled="isFieldEmpty(structure.placeholder)">
																	<BIconTranslate />
																</b-btn>
															</template>
														</b-input-group>
													</b-form-group>
												</b-col>
												<b-col cols="12">
													<b-form-group
														:id="`fieldset-${sub_code}-checkbox-content-${str_idx}-value-${selected_contents_lang}`"
														:label="`(value, 번역 안함) ${isFieldEmpty(structure.value) ? '(없음)' : structure.value}`"
														:label-for="`input-checkbox-${sub_code}-content-${str_idx}-value`"
														>
														<b-form-input
															:id="`input-checkbox-${sub_code}-content-${str_idx}-value`"
															v-model="structure.value"
															disabled
															readonly
															trim
															/>
													</b-form-group>
												</b-col>
											</b-row>
										</b-td>
									</b-tr>
								</template>
							</b-tbody>
						</b-table-simple>
					</template>
					<!-- sub_type === 'table' ~ (start) -->
					<template v-else-if="sub_type === 'table'">
						<EditingTranslationTable
							:sub_code="sub_code"
							:sub_type="sub_type"
							:sub_data_content="editable_sub_data_contents"
							:request_edited_table_subData="request_edited_table_subData"
							@emit_has_table_translation="on_has_table_translation"
							@emit_is_edited_table="on_is_edited_table"
							@send_edited_table_subDataContens="save_edited_table_subDataContens"
							/>
					</template>
					<!-- sub_type === 'textbox' ~ (start) -->
					<template v-else-if="sub_type === 'textbox'">
						<b-table-simple bordered hover>
							<b-thead>
								<b-tr>
									<b-th> placeholder - 영어 </b-th>
									<b-th> placeholder - 중어 </b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<b-tr>
									<b-td>
										<b-form-group
											:id="`fieldset-textbox-${sub_code}-element_contents-placeholder-ea`"
											:label="`(국문) ${!editable_sub_data_contents.placeholder || editable_sub_data_contents.placeholder === '' ? '(없음)' : editable_sub_data_contents.placeholder}`"
											:label-for="`input-textbox-${sub_code}-element_contents-placeholder-ea`"
											>

											<b-input-group>
												<b-form-input
													:id="`input-textbox-${sub_code}-element_contents-placeholder-ea`"
													v-model="editable_sub_data_contents.placeholder_ea"
													@input="changeEditingSubDataContents"
													:placeholder="!editable_sub_data_contents.placeholder ? '(미사용)' : '번역 자동 생성를 통해 번역을 생성 후 수정하실 수 있으십니다.'"
													:disabled="!editable_sub_data_contents.placeholder"
													trim
													/>	

												<template #append>
													<b-btn variant="warning" size="sm"
														@click="generateTempTranslation(editable_sub_data_contents.placeholder, 'ea')"
														:disabled="isFieldEmpty(editable_sub_data_contents.placeholder)">
														<BIconTranslate />
													</b-btn>
												</template>
											</b-input-group>
										</b-form-group>
									</b-td>
									<b-td>
										<b-form-group
											:id="`fieldset-textbox-${sub_code}-element_contents-placeholder-ca`"
											:label="`(국문) ${!editable_sub_data_contents.placeholder || editable_sub_data_contents.placeholder === '' ? '(없음)' : editable_sub_data_contents.placeholder}`"
											:label-for="`input-textbox-${sub_code}-element_contents-placeholder-ca`"
											>

											<b-input-group>
												<b-form-input
													:id="`input-textbox-${sub_code}-element_contents-placeholder-ca`"
													v-model="editable_sub_data_contents.placeholder_ca"
													@input="changeEditingSubDataContents"
													:placeholder="!editable_sub_data_contents.placeholder ? '(미사용)' : '번역 자동 생성를 통해 번역을 생성 후 수정하실 수 있으십니다.'"
													:disabled="isFieldEmpty(editable_sub_data_contents.placeholder)"
													trim
													/>

												<template #append>
													<b-btn variant="warning" size="sm"
														@click="generateTempTranslation(editable_sub_data_contents.placeholder, 'ca')"
														:disabled="isFieldEmpty(editable_sub_data_contents.placeholder)">
														<BIconTranslate />
													</b-btn>
												</template>
											</b-input-group>
										</b-form-group>
									</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</template>
					<!-- sub_type === 'file_URL2', 'guide_text' ~ (start) -->
					<template v-else-if="['file_URL2', 'guide_text', 'guide_text2'].includes(sub_type)">
						<div class="d-flex align-items-center justify-content-center p-4 bgray-200">
							<h6 class="font-italic gray-500 mb-0">(미지원 sub type)</h6>
						</div>
					</template>
				</b-col>
			</b-row>
		</b-col>

		<template v-if="has_element_contents">
			<b-col cols="12" class="border-top pt-3 mb-3">
				<div class="d-flex align-items-center justify-content-between">
					<h6 class="mb-0"> 하위요소 번역 </h6>
					<div>
						<b-form-select size="sm"
							class="w-auto mr-2"
							v-model="selected_contents_lang"
							:options="sub_conetent_data_lang"
							:disabled="disabled_select_language_by_sub_type && !has_element_contents"
							/>
						<b-btn size="sm"
							variant="primary"
							:disabled="is_translation_busy || (!has_sub_data_translation && !has_element_contents) || !is_edited_sub_element_contents"
							@click="saveEditedSubDataContent"
							>
							저장
						</b-btn>
					</div>
				</div>
			</b-col>

			<b-col cols="12">
				<b-table-simple bordered>
					<b-thead>
						<b-tr>
							<b-th> index </b-th>
							<b-th> element </b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<template v-for="(structure, str_idx) in editable_sub_data_contents.structure">
							<b-tr v-if="Object.keys(structure).length"
								:key="`radio-${sub_code}-sub_data_contents-structure-${str_idx}`"
								>
								<b-td>
									{{ Number(str_idx) + 1 }}
								</b-td>
								<template v-if="!structure.element_contents || !structure.element_contents.length">
									<b-td>
										<i class="text-muted">(없음)</i>
									</b-td>
								</template>
								<template v-else>
									<b-td>
										<template v-for="(element, element_idx) in structure.element_contents">
											<!-- sub_type === 'radio' ~ element_content ~ 'input_text', 'input_number' ~ (start) -->
											<template v-if="['input_text', 'input_number'].includes(element.type)">
												<b-table-simple
													:key="`radio-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													:id="`radio-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													>

													<b-thead>
														<b-tr>
															<b-th colspan="4">
																sub_type: {{ element.type }}
															</b-th>
														</b-tr>
													</b-thead>

													<b-tbody>
														<b-tr>
															<b-td>
																{{ Number(element_idx) + 1 }}
															</b-td>
															<b-td>
																<b-row>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-label-${selected_contents_lang}`"
																			:label="`(입력창 제목, 국문) ${!element.structure.label ? '(없음)' : element.structure.label}`"
																			:label-for="`input-radio-${sub_code}-content-${str_idx}-element_contents-${element_idx}-label-${selected_contents_lang}`"
																			>
																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-label-ea`"
																					v-model="element.structure.label_ea"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.label)"
																					trim
																					/>
																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-label-ca`"
																					v-model="element.structure.label_ca"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.label)"
																					trim
																					/>

																				<template #append>
																					<b-btn variant="warning" size="sm"
																						@click="generateTempTranslation(element.structure.label)"
																						:disabled="isFieldEmpty(element.structure.label)">
																						<BIconTranslate />
																					</b-btn>
																				</template>
																			</b-input-group>
																		</b-form-group>
																	</b-col>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-pre_text-${selected_contents_lang}`"
																			:label="`(입력창 앞말, 국문) ${element.structure.pre_text === '' ? '(없음)' : element.structure.pre_text}`"
																			:label-for="`input-radio-${sub_code}-content-${str_idx}-element_contents-${element_idx}-pre_text-${selected_contents_lang}`"
																			>
																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-pre_text-ea`"
																					v-model="element.structure.pre_text_ea"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.pre_text)"
																					trim
																					/>
																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-pre_text-ca`"
																					v-model="element.structure.pre_text_ca"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.pre_text)"
																					trim
																					/>

																				<template #append>
																					<b-btn variant="warning" size="sm"
																						@click="generateTempTranslation(element.structure.pre_text)"
																						:disabled="isFieldEmpty(element.structure.pre_text)">
																						<BIconTranslate />
																					</b-btn>
																				</template>
																			</b-input-group>
																			
																		</b-form-group>
																	</b-col>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-placeholder-${selected_contents_lang}`"
																			:label="`(가이드 텍스트, 국문) ${!element.structure.placeholder ? '(없음)' : element.structure.placeholder}`"
																			:label-for="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-placeholder-${selected_contents_lang}`"
																			>

                                                                            <b-form-text :id="`input-checkbox-${sub_code}-content-${str_idx}-placeholder-help-block`" class="font-italic mb-1">
                                                                                입력창 가이드 문구가 없을 경우, 기본 문구인 국문은 "상세설명"이, 외국어는 번역되어 기본 문구가 출력됩니다.
                                                                            </b-form-text>

																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-placeholder-ea`"
																					v-model="element.structure.placeholder_ea"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.placeholder)"
																					trim
																					/>
																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-placeholder-ca`"
																					v-model="element.structure.placeholder_ca"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.placeholder)"
																					trim
																					/>

																				<template #append>
																					<b-btn variant="warning" size="sm"
																						@click="generateTempTranslation(element.structure.placeholder)"
																						:disabled="isFieldEmpty(element.structure.placeholder)">
																						<BIconTranslate />
																					</b-btn>
																				</template>
																			</b-input-group>
																		</b-form-group>
																	</b-col>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-after_text-${selected_contents_lang}`"
																			:label="`(입력창 뒷말, 국문) ${!element.structure.after_text ? '(없음)' : element.structure.after_text}`"
																			:label-for="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-after_text-${selected_contents_lang}`"
																			>
																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-after_text-ea`"
																					v-model="element.structure.after_text_ea"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.after_text)"
																					trim
																					/>

																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-after_text-ca`"
																					v-model="element.structure.after_text_ca"
																					@input="changeEditingSubElementContents"
																					placeholder="번역 자동 생성를 통해 번역 생성 후 수정하실 수 있으십니다."
																					:disabled="isFieldEmpty(element.structure.after_text)"
																					trim
																					/>

																				<template #append>
																					<b-btn variant="warning" size="sm"
																						@click="generateTempTranslation(element.structure.after_text)"
																						:disabled="isFieldEmpty(element.structure.after_text)">
																						<BIconTranslate />
																					</b-btn>
																				</template>
																			</b-input-group>
																		</b-form-group>
																	</b-col>
																</b-row>
															</b-td>
														</b-tr>
													</b-tbody>
												</b-table-simple>
											</template>

											<!-- sub_type === 'radio'or'checkbox' ~ element_content ~ 'radio' ~ (start) -->
											<template v-if="element.type === 'radio'">
												<b-table-simple
													:key="`radio-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													:id="`radio-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													>
													<b-thead>
														<b-tr>
															<b-th colspan="4">
																sub_type: {{ element.type }}
															</b-th>
														</b-tr>
													</b-thead>
													<b-tbody>
														<b-tr v-for="(ele_structure, ele_str_idx) in element.structure"
															:key="`radio-${sub_code}-structure-${str_idx}-element-${element_idx}-type-${element.type}-structure-${ele_str_idx}`"
															>
															<b-td>
																{{ Number(str_idx) + 1 }}
															</b-td>
															<b-td>
																<b-row>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-${sub_code}-radio-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-${selected_contents_lang}`"
																			:label="`(문구, 국문) ${isFieldEmpty(ele_structure.text) ? '(없음)' : ele_structure.text}`"
																			:label-for="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-${selected_contents_lang}`"
																			>
																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-ea`"
																					v-model="ele_structure.text_ea"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.text) ? '국문 - 문구를 먼저 입력해주세요' : '문구 - 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.text)"
																					trim
																					/>
                                                                                    
																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-ca`"
																					v-model="ele_structure.text_ca"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.text) ? '국문 - 문구를 먼저 입력해주세요' : '문구 - 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.text)"
																					trim
																					/>

																				<template #append>
																					<b-btn variant="warning" size="sm"
																						@click="generateTempTranslation(ele_structure.text)"
																						:disabled="isFieldEmpty(ele_structure.text)">
																						<BIconTranslate />
																					</b-btn>
																				</template>
																			</b-input-group>
																		</b-form-group>
																	</b-col>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-${sub_code}-radio-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-${selected_contents_lang}`"
																			:label="`(입력창 가이드 문구, 국문) ${isFieldEmpty(ele_structure.placeholder) ? '(없음)' : ele_structure.placeholder}`"
																			:label-for="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-${selected_contents_lang}`"
																			>

                                                                            <b-form-text :id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-help-block`" class="font-italic mb-1">
                                                                                입력창 가이드 문구가 없을 경우, 기본 문구인 국문은 "상세설명"이, 외국어는 번역되어 기본 문구가 출력됩니다.
                                                                            </b-form-text>

																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-ea`"
																					v-model="ele_structure.placeholder_ea"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.placeholder) ? '국문 - 가이드 문구를 먼저 입력해주세요.' : '가이드 문구 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.placeholder)"
																					trim
																					/>

																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-ca`"
																					v-model="ele_structure.placeholder_ca"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.placeholder) ? '국문 - 가이드 문구를 먼저 입력해주세요.' : '가이드 문구 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.placeholder)"
																					trim
																					/>

																				<template #append>
																					<b-btn variant="warning" size="sm"
																						@click="generateTempTranslation(ele_structure.placeholder)"
																						:disabled="isFieldEmpty(ele_structure.placeholder)">
																						<BIconTranslate />
																					</b-btn>
																				</template>
																			</b-input-group>
																		</b-form-group>
																	</b-col>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-${sub_code}-radio-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-value`"
																			:label="`(value, 번역 안함) ${isFieldEmpty(structure.value) === '' ? '(없음)' : structure.value}`"
																			:label-for="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-value`"
																			>
																			<b-form-input
																				:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-value`"
																				v-model="structure.value"
																				disabled
																				readonly
																				trim
																				/>
																		</b-form-group>
																	</b-col>
																</b-row>
															</b-td>
														</b-tr>
													</b-tbody>
												</b-table-simple>
											</template>
											
											<!-- sub_type === 'radio' ~ element_content ~ 'checkbox' ~ (start) -->
											<template v-if="element.type === 'checkbox'">
												<b-table-simple
													:key="`checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													:id="`checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													>
													<b-thead>
														<b-tr>
															<b-th colspan="4">
																sub_type: {{ element.type }}
															</b-th>
														</b-tr>
													</b-thead>
													<b-tbody>
														<b-tr v-for="(ele_structure, ele_str_idx) in element.structure"
															:key="`checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-type-${element.type}-structure-${ele_str_idx}`"
															>
															<b-td>
																{{ Number(str_idx) + 1 }}
															</b-td>
															<b-td>
																<b-row>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-${sub_code}-checkbox-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-${selected_contents_lang}`"
																			:label="`(문구, 국문) ${isFieldEmpty(ele_structure.text) ? '(없음)' : ele_structure.text}`"
																			:label-for="`input-checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-${selected_contents_lang}`"
																			>
																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-ea`"
																					v-model="ele_structure.text_ea"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.text) ? '국문 - 문구를 먼저 입력해주세요' : '문구 - 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.text)"
																					trim
																					/>
                                                                                    
																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-text-ca`"
																					v-model="ele_structure.text_ca"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.text) ? '국문 - 문구를 먼저 입력해주세요' : '문구 - 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.text)"
																					trim
																					/>
																			</b-input-group>
																			
																			<template #append>
																				<b-btn variant="warning" size="sm"
																					@click="generateTempTranslation(ele_structure.text)"
																					:disabled="isFieldEmpty(ele_structure.text)">
																					<BIconTranslate />
																				</b-btn>
																			</template>
																		</b-form-group>
																	</b-col>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-${sub_code}-checkbox-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-${selected_contents_lang}`"
																			:label="`(입력창 가이드 문구, 국문) ${isFieldEmpty(ele_structure.placeholder) ? '(없음)' : ele_structure.placeholder}`"
																			:label-for="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-${selected_contents_lang}`"
																			>

                                                                            <b-form-text :id="`input-checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-help-block`" class="font-italic mb-1">
                                                                                입력창 가이드 문구가 없을 경우, 기본 문구인 국문은 "상세설명"이, 외국어는 번역되어 기본 문구가 출력됩니다.
                                                                            </b-form-text>

																			<b-input-group>
																				<b-form-input
																					v-show="selected_contents_lang === 'ea'"
																					:id="`input-checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-ea`"
																					v-model="ele_structure.placeholder_ea"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.placeholder) ? '국문 - 가이드 문구를 먼저 입력해주세요.' : '가이드 문구 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.placeholder)"
																					trim
																					/>

																				<b-form-input
																					v-show="selected_contents_lang === 'ca'"
																					:id="`input-checkbox-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-placeholder-ca`"
																					v-model="ele_structure.placeholder_ca"
																					@input="changeEditingSubElementContents"
																					:placeholder="isFieldEmpty(ele_structure.placeholder) ? '국문 - 가이드 문구를 먼저 입력해주세요.' : '가이드 문구 번역을 입력해주세요'"
																					:disabled="isFieldEmpty(ele_structure.placeholder)"
																					trim
																					/>

																				<template #append>
																					<b-btn variant="warning" size="sm"
																						@click="generateTempTranslation(ele_structure.placeholder)"
																						:disabled="isFieldEmpty(ele_structure.placeholder)">
																						<BIconTranslate />
																					</b-btn>
																				</template>
																			</b-input-group>
																		</b-form-group>
																	</b-col>
																	<b-col cols="12">
																		<b-form-group
																			:id="`fieldset-${sub_code}-checkbox-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-value`"
																			:label="`(value, 번역 안함) ${isFieldEmpty(structure.value) === '' ? '(없음)' : structure.value}`"
																			:label-for="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-value`"
																			>
																			<b-form-input
																				:id="`input-radio-${sub_code}-structure-${str_idx}-element-${element_idx}-structure-${ele_str_idx}-value`"
																				v-model="structure.value"
																				disabled
																				readonly
																				trim
																				/>
																		</b-form-group>
																	</b-col>
																</b-row>
															</b-td>
														</b-tr>
													</b-tbody>
												</b-table-simple>
											</template>

											<!-- sub_type === 'radio' ~ element_content ~ 'table' ~ (start) -->
											<template v-if="element.type === 'table'">
												<EditingTranslationTable
													:key="`radio-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													:id="`radio-${sub_code}-structure-${str_idx}-element-${element_idx}-table`"
													:sub_type="element.type"
													:sub_code="sub_code"
													:sub_data_content="element"
													:content_index="str_idx"
													:element_index="element_idx"
													:is_element="true"
													:request_edited_table_subData="request_edited_table_subData"
													@emit_has_table_translation="on_has_table_translation"
													@emit_is_edited_table="on_is_edited_table"
													@send_edited_table_subDataContens="save_edited_table_subDataContens"
													/>
											</template>
										</template>
									</b-td>
								</template>
							</b-tr>
						</template>
					</b-tbody>
				</b-table-simple>
			</b-col>
		</template>
	</b-row>
</template>

<script>
import { mapMutations } from 'vuex';
import { debounce } from 'lodash';
import { getErrorMessage } from '@core/utils/api/errorMessage';
import translationSubComponent from '@core_mixins/translation/translationSubComponent';
import EditingTranslationTable from '@core_components/admin/components/subs/editing/EditingTranslationTable.vue';

export default {
	name: 'EditingTranslation',
	props: {
        sub_code: {
            type: String,
            default: ''
        },
        sub_type: {
            type: String,
            default: ''
        },
		sub_data: {
            type: [ String, Object, Array ]            
        }
    },
	components: {
		EditingTranslationTable
	},
	mixins: [
		translationSubComponent
	],
	data () {
		return {
			sub_meta_lang: [
				{ text: '영어', value: 'ea' },
				{ text: '중문', value: 'ca' },
			],
			sub_conetent_data_lang: [
				{ text: '영어', value: 'ea' },
				{ text: '중문', value: 'ca' },
			],
			selected_meta_lang: 'ea',
			selected_contents_lang: 'ea',
			editable_sub_data_meta: {
				sub_data_name_e: null,
				sub_data_name_c: null,
				sub_data_description_e: null,
				sub_data_description_c: null,
				sub_data_info_e: null,
				sub_data_info_c: null,
				enable_na_label_ea: null,
				enable_na_label_ca: null
			},
			editable_sub_data: {},
			editable_sub_data_contents: {},
			is_edited_meta_data: false,
			has_sub_meta_translation: false,
			has_radio_translation: true,
			has_checkbox_translation: true,
			has_textbox_translation: true,
			has_table_translation: true,
			request_edited_table_subData: false,
			is_translation_busy: false
		}
	},
	computed: {
		has_element_contents () {
			if (this.sub_type !== 'radio') {
				return false
			} else {
				return this.sub_data.sub_data_contents.structure.some((_structure => !!_structure.element_contents && _structure.element_contents.length))
			}
		},
		has_sub_data_translation () {
			return this.has_radio_translation &&
				this.has_checkbox_translation &&
				this.has_textbox_translation &&
				this.has_table_translation
		},
		has_table_element () {
			return this.sub_data.sub_data_contents.structure.reduce((_has_table_element, structure) => {
				if (!_has_table_element && structure.element_contents) {
					_has_table_element = structure.element_contents.reduce((_is_table_element, _element) => {
						if (!_is_table_element && _element.type === 'table') {
							_is_table_element = true
						}
						return _is_table_element
					}, false)
				}
				return _has_table_element
			}, false)
		},
		disabled_select_language_by_sub_type () {
			return ['textbox', 'file_URL2', 'guide_text', 'guide_text2'].includes(this.sub_type)
		}
	},
	watch: {
		sub_data (_updated_sub_data) {
			if (_updated_sub_data) {
				this.generate_editable_sub_data(_updated_sub_data)
				this.validate_sub_type_translation()
			}
		}
	},
	created () {
		this.generate_editable_sub_data()
	},
	mounted () {
		this.validate_meta_translation()
		this.validate_sub_type_translation()
	},
	beforeDestroy () {
		this.is_edited_meta_data = false
		this.has_sub_meta_translation = false
		this.has_radio_translation = true
		this.has_checkbox_translation = true
		this.has_textbox_translation = true
		this.has_table_translation = true
		this.request_edited_table_subData = false

		this.editable_sub_data_meta = {
			sub_name_e: null,
			sub_name_c: null,
			sub_description_e: null,
			sub_description_c: null,
			sub_info_e: null,
			sub_info_c: null,
			enable_na_label_ea: null,
			enable_na_label_ca: null
		}
	},
	methods: {
		...mapMutations(['update_question_sub']),
		resetSubMeta (_sub_data = this.sub_data) {
			if (this.is_edited_meta_data) {
				const _is_confirmed_reset_sub_meta = confirm('제목 & 설명에서 편집된 내용이 있습니다. 정말로 되돌리십니까?')
				if (_is_confirmed_reset_sub_meta) {
					_sub_data = JSON.stringify(_sub_data)
					this.editable_sub_data = JSON.parse(_sub_data)

					const {
						sub_name_e, sub_name_c,
						sub_description_e, sub_description_c,
						sub_info_e, sub_info_c,
						sub_data_header
					} = JSON.parse(_sub_data)

					const {
						enable_na_label_ca, enable_na_label_ea
					} = sub_data_header

					this.editable_sub_data_meta = {
						sub_name_e, sub_name_c,
						sub_description_e, sub_description_c,
						sub_info_e, sub_info_c,
						enable_na_label_ca, enable_na_label_ea
					}

					this.validate_meta_translation()
					this.is_edited_meta_data = false
				}
			}
		},
		resetSubDataContent (_sub_data = this.sub_data) {
			if (this.is_edited_sub_data_contents) {
				const _is_confirmed_reset_sub_data_content = confirm('문항(Structure) 또는 하위요소 에서 편집된 내용이 있습니다. 정말로 되돌리십니까?')
				if (_is_confirmed_reset_sub_data_content) {
					_sub_data = JSON.stringify(_sub_data)
					this.editable_sub_data = JSON.parse(_sub_data)

					const {
						sub_data_contents
					} = JSON.parse(_sub_data)

					const _sub_data_contents = JSON.stringify(sub_data_contents)
					this.editable_sub_data_contents = JSON.parse(_sub_data_contents)

					this.validate_sub_type_translation()
					this.is_edited_sub_data_contents = false
				}
			}
		},
		generate_editable_sub_data (_sub_data = this.sub_data) {
			_sub_data = JSON.stringify(_sub_data)
			this.editable_sub_data = JSON.parse(_sub_data)

			const {
				sub_name_e, sub_name_c,
				sub_description_e, sub_description_c,
				sub_info_e, sub_info_c,
				sub_data_header,
				sub_data_contents
			} = JSON.parse(_sub_data)

			const {
				enable_na_label_ca, enable_na_label_ea
			} = sub_data_header

			this.editable_sub_data_meta = {
				sub_name_e, sub_name_c,
				sub_description_e, sub_description_c,
				sub_info_e, sub_info_c,
				enable_na_label_ca, enable_na_label_ea
			}

			const _sub_data_contents = JSON.stringify(sub_data_contents)
			this.editable_sub_data_contents = JSON.parse(_sub_data_contents)

			this.validate_meta_translation()
			this.is_edited_meta_data = false
			this.is_edited_sub_data_contents = false
		},
		/** 번역 저장/자동 생성 공통 실행기: 중복 클릭 방지, 성공/실패 토스트. task 가 false 를 돌려주면(취소·변경 없음) 토스트 없이 끝낸다. */
		async runTranslationTask (label, task) {
			if (this.is_translation_busy) return
			try {
				this.is_translation_busy = true
				if (await task() === false) return
				this.$EventBus.$emit('toast-success', '성공', `${label}을(를) 완료하였습니다.`)
			} catch (error) {
				this.$EventBus.$emit('toast-failure', `${label} 실패`, getErrorMessage(error, error && error.message ? error.message : '요청을 처리하지 못했습니다. 입력한 내용은 그대로 두었으니 다시 시도해주세요.'))
			} finally {
				this.is_translation_busy = false
			}
		},
		generateSubMetaTraslation () {
			return this.runTranslationTask('번역 자동 생성', () => this.doGenerateSubMetaTraslation())
		},
		async doGenerateSubMetaTraslation () {
			const is_confirmed_initialize_sub_meta = await this.$showModal({
				type: 'confirm', state: 'warning', title: '번역 자동 생성',
				message: '번역 자동 생성(서버 번역 호출)을 할 경우, 기존 수정된 내역도 덮어쓰기가 됩니다. 진행하시겠습니까?'
			})
			if (!is_confirmed_initialize_sub_meta) return false
			{

				const _res_init_meta_translation = await this.$axios.post(`/translate/subs_init/${this.sub_code}`,
					{ sub: this.editable_sub_data },
					{ params: { init_translation: true, partial_translation: true, translation_part: 'meta' } }
				)

				this.update_question_sub(_res_init_meta_translation.data)
			}
		},
		on_has_table_translation (_has_table_translation) {
			if (_has_table_translation.is_element) {
				this.has_radio_translation = _has_table_translation.has_status
			} else {
				this.has_table_translation = _has_table_translation.has_status
			}
		},
		on_is_edited_table (_is_edited_table_translation) {
			if (_is_edited_table_translation.is_element) {
				this.is_edited_sub_element_contents = _is_edited_table_translation.edited_status
			} else {
				this.is_edited_sub_data_contents = _is_edited_table_translation.edited_status
			}
		},
		checkIsEditingMetaData: debounce(function (edited, origin) {
			this.is_edited_meta_data = origin !== edited
			this.validate_meta_translation()
		}, 250),
		validate_meta_translation () {
			const _meta_field = ['sub_description', 'sub_info']
			const _has_sub_meta_translation = _meta_field.every(_meta => {
				return this.isFieldEmpty(this.editable_sub_data[_meta])
					? true
					: !this.isFieldEmpty(this.editable_sub_data_meta[`${_meta}_e`]) && !this.isFieldEmpty(this.editable_sub_data_meta[`${_meta}_c`])
			})

			const _enable_na_field_field = ['enable_na_label_ca', 'enable_na_label_ea']
			let _has_sub_enable_na_translation = _enable_na_field_field.every(_meta => {
				return this.isFieldEmpty(this.editable_sub_data['sub_data_header'][_meta])
					? true
					: !this.isFieldEmpty(this.editable_sub_data_meta[_meta])
			})

			this.has_sub_meta_translation = _has_sub_meta_translation && _has_sub_enable_na_translation
		},
		saveEditedSubMetaData () {
			return this.runTranslationTask('타이틀 & 설명 번역 저장', () => this.doSaveEditedSubMetaData())
		},
		async doSaveEditedSubMetaData () {
			this.validate_meta_translation()
			if (!this.has_sub_meta_translation) return false
			{
				const {
					sub_name_e, sub_name_c,
					sub_description_e, sub_description_c,
					sub_info_e, sub_info_c,
					enable_na_label_ea, enable_na_label_ca
				} = this.editable_sub_data_meta

				let _edited_sub_data_meta = {
					...this.editable_sub_data,
					sub_name_e, sub_name_c,
					sub_description_e, sub_description_c,
					sub_info_e, sub_info_c
				}

				_edited_sub_data_meta['sub_data_header'] = {
					..._edited_sub_data_meta['sub_data_header'],
					enable_na_label_ea, enable_na_label_ca
				}

				if (typeof _edited_sub_data_meta['sub_data_header']['enable_na_label_en'] !== 'undefined') {
					delete _edited_sub_data_meta['sub_data_header']['enable_na_label_en']
				}

				const _res_update_meta_translation = await this.$axios.post(`/translate/subs_init/${this.sub_code}`, 
					{ sub: _edited_sub_data_meta },
					{
						params: {
							init_translation: false,
							partial_translation: true,
							translation_part: 'meta'
						}
					}
				)
				
				this.update_question_sub(_res_update_meta_translation.data)
			}
		},
		saveEditedSubDataContent () {
			this.validate_sub_type_translation()
			if (this.sub_type === 'table' || this.has_table_element) {
				// 실제 저장은 표 컴포넌트가 send_edited_table_subDataContens 로 보내올 때 한다(busy 와 무관)
				this.request_edited_table_subData = true
				return
			}
			return this.runTranslationTask('문항 번역 저장', () => this.doSaveEditedSubDataContent())
		},
		async doSaveEditedSubDataContent () {
			{
				/**
				 * 여기서는 'table'이외의 sub_type을 저장한다.
				 */
				let is_confirmed_save_edited_sub_meta = false
				let _saving_edited_sub_data = {
					...this.sub_data,
					sub_data_contents: {
						...this.editable_sub_data_contents
					}
				}
				if (this.is_edited_meta_data) {
					is_confirmed_save_edited_sub_meta = confirm('타이틀 & 설명의 번역에서 편집된 내용이 있습니다. 함께 저장하시겠습니까?')
				}

				if (is_confirmed_save_edited_sub_meta) {
					_saving_edited_sub_data = {
						...this.sub_data,
						..._saving_edited_sub_data,
						...this.editable_sub_data_meta
					}
				}

				const _res_update_contents_translation = await this.$axios.post(`/translate/subs_init/${this.sub_code}`,
					{ sub: _saving_edited_sub_data },
					{
						params: {
							init_translation: false,
							partial_translation: true,
							translation_part: 'sub_data_contents'
						}
					})

				this.update_question_sub(_res_update_contents_translation.data)

				if (is_confirmed_save_edited_sub_meta) {
					this.is_edited_meta_data = false
				}
				
				if (this.is_edited_sub_data_contents) {
					this.is_edited_sub_data_contents = false
				}

				if (this.is_edited_sub_element_contents) {
					this.is_edited_sub_element_contents = false
				}
			}
		},
		async save_edited_table_subDataContens (editedTableSubData) {
			// 표가 여러 개면 emit 이 연달아 오므로 busy 로 버리지 말고 순서대로 저장한다
			this.table_save_chain = (this.table_save_chain || Promise.resolve()).then(async () => {
				try {
					this.is_translation_busy = true
					await this.doSaveEditedTableSubDataContens(editedTableSubData)
					this.$EventBus.$emit('toast-success', '성공', '표 번역 저장을(를) 완료하였습니다.')
				} catch (error) {
					this.$EventBus.$emit('toast-failure', '표 번역 저장 실패', getErrorMessage(error, error && error.message ? error.message : '요청을 처리하지 못했습니다. 입력한 내용은 그대로 두었으니 다시 시도해주세요.'))
				} finally {
					this.is_translation_busy = false
					this.request_edited_table_subData = false
				}
			})
			return this.table_save_chain
		},
		async doSaveEditedTableSubDataContens (editedTableSubData) {
			let _saving_sub_data = null
			_saving_sub_data = JSON.parse(_saving_sub_data)
			
			if (this.has_table_element) {
				_saving_sub_data = JSON.stringify({
					...this.sub_data,
					sub_data_contents: {
						...this.editable_sub_data_contents
					}
				})
				_saving_sub_data = JSON.parse(_saving_sub_data)


				if (editedTableSubData.edited_sub_data_contents_structure) {
					_saving_sub_data.sub_data_contents.structure[editedTableSubData.content_index].element_contents[editedTableSubData.element_index].structure = editedTableSubData.edited_sub_data_contents_structure
				}

				if (editedTableSubData.table_header_ea) {
					_saving_sub_data.sub_data_contents.structure[editedTableSubData.content_index].element_contents[editedTableSubData.element_index].table_header_ea = editedTableSubData.table_header_ea
				}
				
				if(editedTableSubData.table_header_ca) {
					_saving_sub_data.sub_data_contents.structure[editedTableSubData.content_index].element_contents[editedTableSubData.element_index].table_header_ca = editedTableSubData.table_header_ca
				}

				if (editedTableSubData.table_title_ea) {
					_saving_sub_data.sub_data_contents.structure[editedTableSubData.content_index].element_contents[editedTableSubData.element_index].table_title_ea = editedTableSubData.table_title_ea
				}
				
				if(editedTableSubData.table_title_ca) {
					_saving_sub_data.sub_data_contents.structure[editedTableSubData.content_index].element_contents[editedTableSubData.element_index].table_title_ca = editedTableSubData.table_title_ca
				}
				
			} else {
				_saving_sub_data = JSON.stringify(this.sub_data)
				_saving_sub_data = JSON.parse(_saving_sub_data)

				if (editedTableSubData.edited_sub_data_contents_structure) {
					_saving_sub_data.sub_data_contents.structure = editedTableSubData.edited_sub_data_contents_structure
				}

				if (editedTableSubData.table_header_ea) {
					_saving_sub_data.sub_data_contents.table_header_ea = editedTableSubData.table_header_ea
				}

				if (editedTableSubData.table_header_ca) {
					_saving_sub_data.sub_data_contents.table_header_ca = editedTableSubData.table_header_ca
				}

				if (editedTableSubData.table_title_ea) {
					_saving_sub_data.sub_data_contents.table_title_ea = editedTableSubData.table_title_ea
				}

				if (editedTableSubData.table_title_ca) {
					_saving_sub_data.sub_data_contents.table_title_ca = editedTableSubData.table_title_ca
				}
			}
			
			const _res_update_contents_translation = await this.$axios.post(`/translate/subs_init/${this.sub_code}`,
				{ sub: _saving_sub_data },
				{ 	params: {
						init_translation: false,
						partial_translation: true,
						translation_part: 'sub_data_contents'
					}
				})

			this.update_question_sub(_res_update_contents_translation.data)

			this.request_edited_table_subData = false
		},
		generateSubDataContentTraslation () {
			return this.runTranslationTask('번역 자동 생성', () => this.doGenerateSubDataContentTraslation())
		},
		async doGenerateSubDataContentTraslation () {
			const is_confirmed_initialize_sub_data_contents = await this.$showModal({
				type: 'confirm', state: 'warning', title: '번역 자동 생성',
				message: '번역 자동 생성(서버 번역 호출)을 할 경우, 기존 수정된 내역도 덮어쓰기가 됩니다. 진행하시겠습니까?'
			})
			if (!is_confirmed_initialize_sub_data_contents) return false
			{
				const _res_init_meta_translation = await this.$axios.post(`/translate/subs_init/${this.sub_code}`,
					{ sub: this.editable_sub_data },
					{
						params: {
							init_translation: true,
							partial_translation: true,
							translation_part: 'sub_data_contents'
						}
					}
				)

				this.update_question_sub(_res_init_meta_translation.data)
			}
		},
		async generateTempTranslation(kr, lang = this.selected_meta_lang ?? this.selected_contents_lang ) {

            const lang_codes = {'zh-cn': 'ca', 'en-US': "ea"}
			const _res_translated = await this.$axios.get("/translate", {
                params: {
                    target_lang: lang_codes[lang] ?? lang,
                    text: kr
                }
            })

			prompt("Ctrl+C를 눌러 복사 후 메모장 에서 확인 또는 바로 번역 입력란에 붙여넣기 하세요.", _res_translated.data);
		}
	}
}
</script>

<style>

</style>
